import React from "react";
import {goToResults, Lesson} from "../api/lessons";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import { Theme, createStyles, withStyles } from "@material-ui/core/styles";

interface Props {
  classes: any;
  max: number;
  lessons: Lesson[];
  history: any;
}

interface State {
  history: any;
}

/**
 * Lessons list.
 * Adds list of lessons.
 */
class LessonsList extends React.Component<Props, State> {
  public render() {
    const { classes } = this.props;
    return (
      <List className={classes.root}>
        {this.props.lessons.map((prop, key) => {
          return (
            <React.Fragment>
              {key > 0 &&
                <Divider component="li"/>
              }
              <ListItem button alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar alt={prop.organization + "-" + prop.name} src="/static/images/organizations/sut.png" />
                </ListItemAvatar>
                <ListItemText
                  primary={prop.name}
                  secondary={
                    <React.Fragment>
                      <Typography variant="body2">
                        {prop.organization}
                      </Typography>
                      <Typography variant="body2">
                        {prop.shortDescription}
                      </Typography>
                      {prop.interests.map((prop, key) => {
                        return (
                          <React.Fragment>
                              {key > 0 ? ", " : ""}
                            <Tooltip title={prop + ": найти занятия в Волгодонске"} className={classes.inline}>
                              <Button
                                size="small"
                                color="secondary"
                                onClick={() => goToResults([prop], this.props.history)}
                              >
                                {prop}
                              </Button>
                            </Tooltip>
                          </React.Fragment>
                        )
                      })}
                    </React.Fragment>
                  }
                />
              </ListItem>
            </React.Fragment>
          )
        })}
      </List>
    );
  }
}

const style = (theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      minWidth: 480,
      maxWidth: "lg",
      backgroundColor: theme.palette.background.paper,
    },
    inline: {
      display: 'inline',
    },
  }
);

export default withStyles(style)(LessonsList);
